// swiperを設定
const relevanceItemsSwiper = new Swiper('.productDetail__info__swiper', {
  slidesPerView: 2.5,
  spaceBetween: 12,
  initialSlide: 0,
  navigation: {
    nextEl: '.productDetail__info__swiper-button-next',
    prevEl: '.productDetail__info__swiper-button-prev',
  },
});
let sliderAdded = false;
const createRelevanceItems = (relevanceItems) => {
  return relevanceItems
    .filter((item) => item.handle !== undefined)
    .map((item) => {
      sliderAdded = true;
      // 現在の日時・商品に登録されている日付を取得
      const currentDate = new Date();
      const initialStart = item.metafield?.value ?? '';

      // product.initial_startの値を日時オブジェクトに変換
      const publishedDate = new Date(initialStart);

      // 現在の日時とproduct.initial_startの差を計算し、10日以内かどうか判定
      const timeDiff = currentDate.getTime() - publishedDate.getTime();
      const twoWeeksInMilliseconds = 10 * 24 * 60 * 60 * 1000; // 10日間のミリ秒数z

      // タグのリストを作成
      const rawTagList = [];
      if (item.tags.includes('sizeL')) {
        rawTagList.push('<p class="productDetail__info__recommend__tag__item">Lサイズ</p>');
      }
      if (item.tags.includes('01-001001025')) {
        rawTagList.push('<p class="productDetail__info__recommend__tag__item">WEB限定</p>');
      }
      if (item.tags.includes('アウトレット')) {
        rawTagList.push('<p class="productDetail__info__recommend__tag__item">OUTLET</p>');
      }
      if (timeDiff <= twoWeeksInMilliseconds) {
        rawTagList.push('<p class="productDetail__info__recommend__tag__item">NEW</p>');
      }
      const tagList = rawTagList.slice(0, 2).join('');

      return `
      <li class="swiper-slide productDetail__info__recommend__slide">
      <a class="productDetail__info__recommend__link" href="/products/${item.handle}">
      <div class="productDetail__info__recommend__container">
       <img
         src="${item.images.edges[0].node.url}&width=300"
         alt=""
         class="productDetail__info__recommend__img"
       >
       <div class="productDetail__info__recommend__tag">${tagList}</div>
      </div>
        <p class="productDetail__info__recommend__text">${item.title}</p>
        <div class="productDetail__info__recommend__price">
        <p class="productDetail__info__recommend__price__amount">¥${Number(
          item.priceRange.minVariantPrice.amount
        ).toLocaleString()}</p>
        <span class="productDetail__info__recommend__price__currencyCode">税込</span>
        </div>
      </a>
    </li>
      `;
    })
    .join('');
};

window.addEventListener('DOMContentLoaded', async () => {
  const loader = document.querySelectorAll('[data-loader-key="relevanceItems"]');
  // 関連商品を取得
  try {
    const relevanceItems = await getRelevanceItems();
    // 関連商品を表示順にソート
    relevanceItems.sort((a, b) => a.order - b.order);
    // PC時はHTMLに関連商品を追加
    const relevanceItemsList = document.querySelector('.productDetail__info__relevance__list');
    relevanceItemsList.innerHTML = createRelevanceItems(relevanceItems);
    // SP時はSwiperにスライドを追加
    relevanceItemsSwiper.appendSlide(createRelevanceItems(relevanceItems));
    // sliderAddedがtrueの場合のみ、relevanceItems関連のdiv要素を表示する
    if (sliderAdded) {
      const relevanceItemsWrappers = document.querySelectorAll('.productDetail__info__description__wrapper.relevanceItems');
      relevanceItemsWrappers.forEach(wrapper => wrapper.style.display = 'block');
    }
    // ローディングを非表示にし、Swiperを表示する
    loader.forEach((loader) => loader.classList.add('hidden'));
      // sliderAddedがfalseの場合、relevanceItems関連のdiv要素を非表示にする
      if (!sliderAdded) {
        const relevanceItemsWrappers = document.querySelectorAll('.productDetail__info__description__wrapper.relevanceItems');
        relevanceItemsWrappers.forEach(wrapper => wrapper.style.display = 'none');
      }
  } catch (error) {
    console.error(error);
  }
});

// 商品ID配列を受け取り、ShopifyのStoreFrontAPIから商品詳細を取得し、商品配列にして返す
const getRelevanceItems = async () => {
  // urlにprodが含まれる場合はprod-sanyo.myshopify.com、それ以外はstg-sanyo.myshopify.com
  const shopDomain = document.querySelector('#shopDomain');
  const SHOPIFY_STOREFRONT_API_URL = `https://${shopDomain.value}/api/2024-10/graphql.json`;
  const STOREFRONT_API_TOKEN = document.querySelector('#storeFrontAccessToken').value;

  const relevanceProducts = JSON.parse(document.getElementById('relevanceItems').innerText || '[]');
  const relevanceItems = [];
  for await (const product of relevanceProducts) {
    const id = product?.productId ?? product.product_id;
    const order = product?.productOrder ?? product.product_order;
    const data = await fetch(`${SHOPIFY_STOREFRONT_API_URL}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': `${STOREFRONT_API_TOKEN}`,
      },
      body: JSON.stringify({
        query: `{
          node(id: "${id}") {
            ... on Product {
              title
              handle
              tags
              priceRange {
                minVariantPrice {
                  amount
                  currencyCode
                }
              }
              images(first: 1) {
                edges {
                  node {
                    url
                  }
                }
              }
              metafield(namespace: "initialstart", key: "filter") {
                key
                value
              }
            }
          }
        }`,
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error();
        }
        return res.json();
      })
      .then((res) => {
        return res.data.node;
      });
    // 商品配列に商品詳細を追加
    relevanceItems.push({
      ...data,
      order,
    });
  }
  return relevanceItems;
};
